import {FilterIcon} from '@heroicons/react/outline'
import {Popover, useMantineTheme} from '@mantine/core'
import React, {useState} from 'react'
import {TransparentActionIcon} from '../consumables/transparent-action-icon'
import {mode} from '@appscience/utils'
import {useDataTableRefsContext} from '../../context'
import {DataTableOneFilterInfo} from '../../model'

interface FilterProps extends DataTableOneFilterInfo {
  disabled?: boolean,
}

export function DataTableFilterAction({
  disabled,
  dropdown,
  filterActive,
}: FilterProps) {
  const {colors, colorScheme} = useMantineTheme()
  const [active, setActive] = useState(!!filterActive)
  const [opened, setOpened] = useState(false)
  const { callbacksRef } = useDataTableRefsContext()

  const getButtonColor = () => (opened || active
    ? mode(colors.blue[4], colors.blue[4])(colorScheme)
    : mode(colors.gray[5], colors.gray[5])(colorScheme))

  return <Popover
    opened={opened}
    onClose={() => setOpened(false)}
    target={
      <TransparentActionIcon disabled={disabled} className='min-w-min w-auto' onClick={() => setOpened(!opened)}>
        <FilterIcon color={getButtonColor()} className='filter-icon w-3.5 h-3.5' />
      </TransparentActionIcon>
    }
    position='bottom'
    withArrow
    spacing={0}
  >
    {dropdown({
      closeFn: () => setOpened(false),
      setActive: isActive => {
        setActive(isActive)
        callbacksRef.current.pagination.onSetPage(0)
        callbacksRef.current.select?.onRemoveAll()
      },
    })}
  </Popover>
}